import React from "react";
import { AnnsModal } from "../../../components/Component";
import { useState } from "react";
import { toCapitalize } from "../../../utils/Functions";

const QueryReasonModal = ({ visible, onClosed, statusData }) => {
  const [loading, setLoading] = useState(false);

  const close = () => {
    onClosed();
    setLoading(false);
  };

  return (
    <>
      <AnnsModal
        size={"md"}
        isOpen={visible}
        toggle={() => close()}
        title={
          statusData?.status === "CANCELLED"
            ? `Cancelled by ${toCapitalize(statusData?.cancelByType ?? "")}`
            : `Reason for Query`
        }
        // onClick={() => onFormSubmit()}
        // disabled={isDisable}
        // isShowHeaderRemove={item ? true : null}
        // loading={loading}
        isFooterHide={true}
      >
        {statusData?.status === "CANCELLED" && <h6 className="fs-20">Reason:</h6>}
        <span className="fs-16">{statusData?.statusReason ?? "N/A"}</span>
      </AnnsModal>
    </>
  );
};

export default QueryReasonModal;
